import { BenchmarkParameter } from "../Models/BenchmarkParameter";
import { AjaxService } from "../Helpers/AjaxService";
import { UrlParameters } from "../Models/Benchmark/UrlParameters";
import { CleaningGerminationReport } from "../Models/Benchmark/CleaningGerminationReport";
import { CleaningPurityReport } from "../Models/Benchmark/CleaningPurityReport";
import { CleaningWasteReport } from "../Models/Benchmark/CleaningWasteReport";
import { YieldCleanedMaterialReport } from "../Models/Benchmark/YieldCleanedMaterialReport";
import { YieldNormalQualityReport } from "../Models/Benchmark/YieldNormalQualityReport";
import { YieldPaymentReport } from "../Models/Benchmark/YieldPaymentReport";

export class BenchmarkApi {
    private static instance: BenchmarkApi;
    static getInstance() { return BenchmarkApi.instance || (BenchmarkApi.instance = new BenchmarkApi()); }

    getBenchmarkParameters(): Promise<BenchmarkParameter[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetParameters.ashx`;
        return new Promise<BenchmarkParameter[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: BenchmarkParameter[]) => {
                    resolve(result);
                });
        });
    }

    getCleaningGerminationReport(urlParameters: UrlParameters): Promise<CleaningGerminationReport[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetCleaningGerminationReport.ashx?postcodebegin=${urlParameters.postCodeBegin}&postcodeend=${urlParameters.postCodeEnd}&year=${urlParameters.year}&cultivationmethod=${urlParameters.cultivationMethod}&varietyIds=${urlParameters.varietyIds}&excludeBornholm=${urlParameters.excludeBornholm}`;
        return new Promise<CleaningGerminationReport[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: CleaningGerminationReport[]) => {
                    resolve(result);
                });
        });
    }

    getCleaningPurityReport(urlParameters: UrlParameters): Promise<CleaningPurityReport[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetCleaningPurityReport.ashx?postcodebegin=${urlParameters.postCodeBegin}&postcodeend=${urlParameters.postCodeEnd}&year=${urlParameters.year}&cultivationmethod=${urlParameters.cultivationMethod}&varietyIds=${urlParameters.varietyIds}&excludeBornholm=${urlParameters.excludeBornholm}`;
        return new Promise<CleaningPurityReport[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: CleaningPurityReport[]) => {
                    resolve(result);
                });
        });
    }

    getCleaningWasteReport(urlParameters: UrlParameters): Promise<CleaningWasteReport[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetCleaningWasteReport.ashx?postcodebegin=${urlParameters.postCodeBegin}&postcodeend=${urlParameters.postCodeEnd}&year=${urlParameters.year}&cultivationmethod=${urlParameters.cultivationMethod}&varietyIds=${urlParameters.varietyIds}&excludeBornholm=${urlParameters.excludeBornholm}`;
        return new Promise<CleaningWasteReport[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: CleaningWasteReport[]) => {
                    resolve(result);
                });
        });
    }

    getYieldCleanedMaterialReport(urlParameters: UrlParameters): Promise<YieldCleanedMaterialReport[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetYieldCleanedMaterialReport.ashx?postcodebegin=${urlParameters.postCodeBegin}&postcodeend=${urlParameters.postCodeEnd}&year=${urlParameters.year}&cultivationmethod=${urlParameters.cultivationMethod}&varietyIds=${urlParameters.varietyIds}&excludeBornholm=${urlParameters.excludeBornholm}`;
        return new Promise<YieldCleanedMaterialReport[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: YieldCleanedMaterialReport[]) => {
                    resolve(result);
                });
        });
    }

    getYieldNormalQualityReport(urlParameters: UrlParameters): Promise<YieldNormalQualityReport[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetYieldNormalQualityReport.ashx?postcodebegin=${urlParameters.postCodeBegin}&postcodeend=${urlParameters.postCodeEnd}&year=${urlParameters.year}&cultivationmethod=${urlParameters.cultivationMethod}&varietyIds=${urlParameters.varietyIds}&excludeBornholm=${urlParameters.excludeBornholm}`;
        return new Promise<YieldNormalQualityReport[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: YieldNormalQualityReport[]) => {
                    resolve(result);
                });
        });
    }

    getYieldPaymentReport(urlParameters: UrlParameters): Promise<YieldPaymentReport[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/Handlers/Benchmark/GetYieldPaymentReport.ashx?postcodebegin=${urlParameters.postCodeBegin}&postcodeend=${urlParameters.postCodeEnd}&year=${urlParameters.year}&cultivationmethod=${urlParameters.cultivationMethod}&varietyIds=${urlParameters.varietyIds}&excludeBornholm=${urlParameters.excludeBornholm}`;
        return new Promise<YieldPaymentReport[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: YieldPaymentReport[]) => {
                    resolve(result);
                });
        });
    }
}

